// Deep links into HexaHQ (the CRM/ERP), which is a separate application on its
// own domain — every one of these opens in a new tab. Centralized so the base
// URL has exactly one definition; it was previously inlined per feature and the
// third copy is how a host change starts silently rotting (sc-6158).
export const HEXAHQ_BASE = 'https://hexahq.com';

export const hexahqOrderUrl = (id: number) => `${HEXAHQ_BASE}/orders/${id}`;

// Quotes open in edit view to match the digest "View Quote in HexaHQ" link
// (backend EdgeAccountDigest#hexahq_quote_url uses /quotes/:id/edit).
export const hexahqQuoteUrl = (id: number) => `${HEXAHQ_BASE}/quotes/${id}/edit`;

export const hexahqAccountUrl = (id: number) => `${HEXAHQ_BASE}/accounts/${id}`;
